import { FeatureSettings } from "../../../components/VehicleFeatures/FeatureSettings";
import { useWorkspace } from "../../../context/WorkspaceContext";

export default function VehicleFeaturesSettingsContent() {
  const { activeWorkspace } = useWorkspace();
  return activeWorkspace?.workspaceId ? (
    <FeatureSettings
      key={activeWorkspace.workspaceId}
      workspaceId={activeWorkspace.workspaceId}
    />
  ) : null;
}
